export const LANDING = '/';
export const SIGN_UP = '/signup';
export const SIGN_IN = '/entrar'; 
export const MAIN = '/main';
export const ACCOUNT = '/account';
export const ADMIN = '/admin';
export const PASSWORD_FORGET = '/pw-forget';

export const TERMO = '/termo';
export const MEUS_DADOS = '/meus_dados';
export const MINHAS_SOLICITACOES = '/minhas_solicitacoes';
export const SOLICITAR = '/solicita_profissional';
export const ESCOLHER_PROFISSIONAL = '/escolher_profissional';